/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Reflex API
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  Blueprint
} from './model/blueprint.js';

import type {
  CreateBlueprintBody
} from './model/createBlueprintBody.js';

import type {
  DeleteBlueprint200
} from './model/deleteBlueprint200.js';

import type {
  GetBlueprintBuildLog200
} from './model/getBlueprintBuildLog200.js';

import type {
  GetBlueprintBuildLogParams
} from './model/getBlueprintBuildLogParams.js';

import type {
  GetBlueprintLogs200
} from './model/getBlueprintLogs200.js';

import { apiFetch } from '../react-mutator.js';



type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * @summary List the org's blueprints.
 */
export const listBlueprints = (

 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<Blueprint[]>(
      {url: `/blueprints`, method: 'GET', signal
    },
      options);
    }




export const getListBlueprintsQueryKey = () => {
    return [
    `/blueprints`
    ] as const;
    }


export const getListBlueprintsQueryOptions = <TData = Awaited<ReturnType<typeof listBlueprints>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listBlueprints>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListBlueprintsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listBlueprints>>> = ({ signal }) => listBlueprints(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listBlueprints>>, TError, TData> & { queryKey: QueryKey }
}

export type ListBlueprintsQueryResult = NonNullable<Awaited<ReturnType<typeof listBlueprints>>>
export type ListBlueprintsQueryError = unknown


/**
 * @summary List the org's blueprints.
 */

export function useListBlueprints<TData = Awaited<ReturnType<typeof listBlueprints>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listBlueprints>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListBlueprintsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * The build runs asynchronously. Poll the blueprint until its status reaches build_complete.
 * @summary Create a blueprint and start its build.
 */
export const createBlueprint = (
    createBlueprintBody: CreateBlueprintBody,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<Blueprint>(
      {url: `/blueprints`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createBlueprintBody, signal
    },
      options);
    }




export const getCreateBlueprintMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createBlueprint>>, TError,{data: CreateBlueprintBody}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createBlueprint>>, TError,{data: CreateBlueprintBody}, TContext> => {

const mutationKey = ['createBlueprint'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createBlueprint>>, {data: CreateBlueprintBody}> = (props) => {
          const {data} = props ?? {};

          return  createBlueprint(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateBlueprintMutationResult = NonNullable<Awaited<ReturnType<typeof createBlueprint>>>
    export type CreateBlueprintMutationBody = CreateBlueprintBody
    export type CreateBlueprintMutationError = unknown

    /**
 * @summary Create a blueprint and start its build.
 */
export const useCreateBlueprint = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createBlueprint>>, TError,{data: CreateBlueprintBody}, TContext>, request?: SecondParameter<typeof apiFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createBlueprint>>,
        TError,
        {data: CreateBlueprintBody},
        TContext
      > => {
      return useMutation(getCreateBlueprintMutationOptions(options));
    }
    /**
 * @summary Get a blueprint by id.
 */
export const getBlueprint = (
    id: string,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<Blueprint>(
      {url: `/blueprints/${encodeURIComponent(String(id))}`, method: 'GET', signal
    },
      options);
    }




export const getGetBlueprintQueryKey = (id: string,) => {
    return [
    `/blueprints/${id}`
    ] as const;
    }


export const getGetBlueprintQueryOptions = <TData = Awaited<ReturnType<typeof getBlueprint>>, TError = unknown>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getBlueprint>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBlueprintQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBlueprint>>> = ({ signal }) => getBlueprint(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBlueprint>>, TError, TData> & { queryKey: QueryKey }
}

export type GetBlueprintQueryResult = NonNullable<Awaited<ReturnType<typeof getBlueprint>>>
export type GetBlueprintQueryError = unknown


/**
 * @summary Get a blueprint by id.
 */

export function useGetBlueprint<TData = Awaited<ReturnType<typeof getBlueprint>>, TError = unknown>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getBlueprint>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetBlueprintQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Delete a blueprint.
 */
export const deleteBlueprint = (
    id: string,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<DeleteBlueprint200>(
      {url: `/blueprints/${encodeURIComponent(String(id))}`, method: 'DELETE', signal
    },
      options);
    }




export const getDeleteBlueprintMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteBlueprint>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteBlueprint>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteBlueprint'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteBlueprint>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteBlueprint(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteBlueprintMutationResult = NonNullable<Awaited<ReturnType<typeof deleteBlueprint>>>

    export type DeleteBlueprintMutationError = unknown

    /**
 * @summary Delete a blueprint.
 */
export const useDeleteBlueprint = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteBlueprint>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteBlueprint>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getDeleteBlueprintMutationOptions(options));
    }
    /**
 * @summary Get a page of a blueprint's build log, with its build state.
 */
export const getBlueprintBuildLog = (
    id: string,
    params?: GetBlueprintBuildLogParams,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<GetBlueprintBuildLog200>(
      {url: `/blueprints/${encodeURIComponent(String(id))}/build-log`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetBlueprintBuildLogQueryKey = (id: string,
    params?: GetBlueprintBuildLogParams,) => {
    return [
    `/blueprints/${id}/build-log`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetBlueprintBuildLogQueryOptions = <TData = Awaited<ReturnType<typeof getBlueprintBuildLog>>, TError = unknown>(id: string,
    params?: GetBlueprintBuildLogParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getBlueprintBuildLog>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBlueprintBuildLogQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBlueprintBuildLog>>> = ({ signal }) => getBlueprintBuildLog(id,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBlueprintBuildLog>>, TError, TData> & { queryKey: QueryKey }
}

export type GetBlueprintBuildLogQueryResult = NonNullable<Awaited<ReturnType<typeof getBlueprintBuildLog>>>
export type GetBlueprintBuildLogQueryError = unknown


/**
 * @summary Get a page of a blueprint's build log, with its build state.
 */

export function useGetBlueprintBuildLog<TData = Awaited<ReturnType<typeof getBlueprintBuildLog>>, TError = unknown>(
 id: string,
    params?: GetBlueprintBuildLogParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getBlueprintBuildLog>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetBlueprintBuildLogQueryOptions(id,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Get a blueprint's build logs.
 */
export const getBlueprintLogs = (
    id: string,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<GetBlueprintLogs200>(
      {url: `/blueprints/${encodeURIComponent(String(id))}/logs`, method: 'GET', signal
    },
      options);
    }




export const getGetBlueprintLogsQueryKey = (id: string,) => {
    return [
    `/blueprints/${id}/logs`
    ] as const;
    }


export const getGetBlueprintLogsQueryOptions = <TData = Awaited<ReturnType<typeof getBlueprintLogs>>, TError = unknown>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getBlueprintLogs>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBlueprintLogsQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBlueprintLogs>>> = ({ signal }) => getBlueprintLogs(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBlueprintLogs>>, TError, TData> & { queryKey: QueryKey }
}

export type GetBlueprintLogsQueryResult = NonNullable<Awaited<ReturnType<typeof getBlueprintLogs>>>
export type GetBlueprintLogsQueryError = unknown


/**
 * @summary Get a blueprint's build logs.
 */

export function useGetBlueprintLogs<TData = Awaited<ReturnType<typeof getBlueprintLogs>>, TError = unknown>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getBlueprintLogs>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetBlueprintLogsQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Starts an asynchronous build under the same name, replaying the stored dockerfile, commands, mounts, build args, and secrets. Poll the returned blueprint until its status reaches build_complete.
 * @summary Rebuild a blueprint from its stored build inputs.
 */
export const rebuildBlueprint = (
    id: string,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<Blueprint>(
      {url: `/blueprints/${encodeURIComponent(String(id))}/rebuild`, method: 'POST', signal
    },
      options);
    }




export const getRebuildBlueprintMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rebuildBlueprint>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof rebuildBlueprint>>, TError,{id: string}, TContext> => {

const mutationKey = ['rebuildBlueprint'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof rebuildBlueprint>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  rebuildBlueprint(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RebuildBlueprintMutationResult = NonNullable<Awaited<ReturnType<typeof rebuildBlueprint>>>

    export type RebuildBlueprintMutationError = unknown

    /**
 * @summary Rebuild a blueprint from its stored build inputs.
 */
export const useRebuildBlueprint = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rebuildBlueprint>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof rebuildBlueprint>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getRebuildBlueprintMutationOptions(options));
    }
